import React from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import Button from '@material-ui/core/Button'

const DeleteConfirm = ({
  confirm,
  setConfirm,
  entryId,
  contractId,
  deleteEntry,
}) => {
  return (
    <Dialog open={confirm} onClose={() => setConfirm(false)}>
      <DialogTitle id="form-dialog-title">
        Excluir cobrança adicional?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Você deseja realmente excluir esta cobrança adicional?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            deleteEntry(contractId, entryId)
          }}
          type="submit"
          variant="contained"
          color="primary"
        >
          Excluir
        </Button>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => setConfirm(false)}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteConfirm
